import { v4 } from "uuid";
import { retrieveFromStorage } from "../Components/Functions";
import { USER_AUTHENTICATION_DATA } from "../Redux/User/types";
import { routers } from "./routers";

const { user } = retrieveFromStorage(USER_AUTHENTICATION_DATA) || {};
export const loggedUser = user || {};

export const sideMenu = {
    top: loggedUser?.role === "SPECIALIST" ? [
        {
            name: "Dashboard",
            icon: "home",
            link: routers.dashboard.base,
            id: v4(),
            menus: [
                {
                    name: "Dashboard",
                    link: routers.dashboard.base
                },
                {
                    divider: true
                },
                {
                    name: "Financial Statement",
                    link: routers.dashboard.financial_statement
                },
            ]
        },
        {
            name: "Appointments",
            icon: "calendar",
            link: routers.dashboard.appointments,
            id: v4(),
            menus: [],
            unread: 0
        },
        {
            name: "Schedules",
            icon: "clock",
            link: routers.dashboard.scheduler,
            id: v4(),
            menus: [],
            unread: 0
        },
        {
            name: "Patients",
            icon: "users",
            link: routers.dashboard.patients,
            id: v4(),
            menus: []
        }
    ] : [
        {
            name: "Dashboard",
            icon: "home",
            link: routers.dashboard.base,
            id: v4(),
            menus: [
                {
                    name: "Dashboard",
                    link: routers.dashboard.base
                },
                {
                    divider: true
                },
                {
                    name: "Financial Statement",
                    link: routers.dashboard.financial_statement
                },
            ]
        },
        {
            name: "Appointments",
            icon: "calendar",
            link: routers.dashboard.appointments,
            id: v4(),
            menus: [],
            unread: 0
        },
        // {
        //     name: "Medical History",
        //     icon: "grid",
        //     link: routers.dashboard.medicalhistory,
        //     id: v4(),
        //     menus: []
        // },
        {
            name: "Favourites",
            icon: "heart",
            link: routers.dashboard.favourites,
            id: v4(),
            menus: []
        }
    ],
    bottom: loggedUser?.role === "SPECIALIST" ? [
        // {
        //     name: "Chats",
        //     icon: "message-circle",
        //     link: routers.dashboard.chats,
        //     id: v4(),
        //     unread: 0,
        //     menus: []
        // },
        {
            name: "eWallet",
            icon: "credit-card",
            link: routers.account.billing,
            id: v4()
        },
    ]: [
        // {
        //     name: "Chats",
        //     icon: "message-circle",
        //     link: routers.dashboard.chats,
        //     id: v4(),
        //     unread: 0,
        //     menus: []
        // },
        {
            name: "Permissions",
            icon: "shield",
            link: routers.dashboard.permissions,
            id: v4(),
            unread: 0,
            menus: []
        }
    ],
    account: loggedUser?.role === "SPECIALIST" ? [
        {
            name: "Profile",
            description: "Manage personal profile",
            icon: "user",
            link: routers.dashboard.profile
        },
        {
            name: "Categories/Services",
            description: "Manage your services",
            icon: "grid",
            link: routers.dashboard.services
        },
        {
            name: "eWallet",
            description: "Manage your eWallet from here",
            icon: "credit-card",
            link: routers.account.billing
        },
    ] :  [
        {
            name: "Profile",
            description: "Manage personal profile",
            icon: "user",
            link: routers.dashboard.profile
        },
        {
            name: "Medical Record",
            description: "Update medical record",
            icon: "plus-circle",
            link: routers.dashboard.medicalrecord
        },
        // {
        //     name: "eWallet",
        //     description: "Manage your eWallet from here",
        //     icon: "credit-card",
        //     link: routers.account.billing
        // },
    ]
};